module.exports = __webpack_public_path__ + "img/background_principal_mov.2bd05a69.png";